import { useEffect, useState, useRef } from 'react';
import { Card, CardBody, CardFooter, Col, Form, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import CloseButton from 'react-bootstrap/CloseButton';
import Swal from 'sweetalert2';
import { ownSubscribe, sendMessage, unSubscribe } from '../../stomp/StompSocket';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import MasterDropdown from '../components/MasterDropdown';
import './MobileWatch.css';

function AddOrderMobile(props) {

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isBuy, setIsBuy] = useState(props.isBuy);
  const [orderType, setOrderType] = useState('MARKET');
  const [clientId, setClientId] = useState(0);
  const [price, setPrice] = useState(0);
  const [lot, setLot] = useState(1); 
  const [qty, setQty] = useState(0); 
  const [userPrice, setUserPrice] = useState(0);
  const [ip, setIp] = useState('');
  const getISTDateTime = () => {
    const now = new Date();
    const offsetIST = 5.5 * 60 * 60 * 1000; 
    const istTime = new Date(now.getTime() + offsetIST)
      .toISOString()
      .slice(0, 16);

    return istTime;
  };
  const [dateTime, setDateTime] = useState(getISTDateTime()); 

  var mkw = props.mkw;
  var user = BullCache.getFromCache('user');
  var scriptId = (props.mkw.id);

  function findScriptById(scriptId) {
     var allScripts = BullCache.getFromCache('allScripts') || {};

    for (const market in allScripts) {
      if (allScripts.hasOwnProperty(market)) {
        for (const commodity in allScripts[market]) {
          if (allScripts[market].hasOwnProperty(commodity)) {
            const scripts = allScripts[market][commodity];

            const selectedScript = scripts.find(script => script.id === scriptId);

            if (selectedScript) {
              return selectedScript;
            }
          }
        }
      }
    }

    return null;
  }
  const script = findScriptById(scriptId);

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

 const handleLotChange = (e) => {
     const newLot = e.target.value ? parseFloat(e.target.value) : ''; // Ensure it defaults to 1 if empty
     setLot(newLot); // Update lot value
 
   };
 
 const isUserChangingQty = useRef(false);
 
 const handleQtyChange = (e) => {
   isUserChangingQty.current = true; // Mark that the user is changing QTY
   const value = e.target.value;
   const rawLot = value ? parseFloat(value) / script.quantity : '';
  const newLot = rawLot !== '' ? (Math.round(rawLot * 100) / 100).toFixed(2) : '';
   setLot(newLot);
   setQty(value);
 };

  const handleOrderType = (e) => {
    setOrderType(e.target.value);
    setPrice(parseFloat(mkw.i4).toFixed(2));
  }

  const handleDateTimeChange = (e) => {
    const newDate= e.target.value; 
    setDateTime(newDate)
  };

useEffect(() => {
  if (script && lot) {
    if (!isUserChangingQty.current) {
      setQty((lot * script.quantity));
    }
    isUserChangingQty.current = false; // Reset after useEffect runs
  }
}, [lot, script?.quantity]);


  useEffect(() => {
    ownSubscribe('/user/topic/addorder', function (msg) {

      if (msg.body) {
        console.debug("", msg.body);
        var orderResp = JSON.parse(msg.body);
        if (orderResp.code === 1) {

          Swal.fire({
            icon: "success",
            text: "Order placed!"
          });
        } else if (orderResp.code === 0) {
          Swal.fire({
            icon: "error",
            html: orderResp.messages
          });
        } else {
          Swal.fire({
            icon: "error",
            text: "Order not placed.... Please contact administrator!"
          });
        }
      }
    }, 'addorder-sub-id');
    return () => {
      unSubscribe('addorder-sub-id');
    }
  }, []);

  function buyOrder() {
    if(!validateLot()){
           Swal.fire({
                  icon: 'error',
                  text: 'Lot in invalid!'
              });
    
          return; 
    }

    if(selectedClient) {
      var type = 'Buy-MP';
      var rate = props.mkw.i4;
      if (orderType === 'LIMIT') {
        type = rate > price ? 'Buy-RL' : 'Buy-SL';
        rate = price;
      }
      var order = {
        "orderType": type, "quantity": qty, lot: lot,
        "rate": userPrice && userPrice > 0 ? userPrice : rate, "scriptId": props.mkw.id, "userId": selectedClient,
        "inLimit": orderType === 'LIMIT' ? true : false,
        "tradeBy": user.adminId, "device": "Browser", "userAgent": navigator.userAgent,
        "dateTime": userPrice && userPrice > 0 ? dateTime : null, "ip": ip
      };

      sendMessage('/app/topic/addorder', JSON.stringify(order));
    } else {
     Swal.fire({
              icon: 'error',
              text: 'Please select client!'
          });
    }
  };
  function sellOrder() {
     if(!validateLot()){
           Swal.fire({
                  icon: 'error',
                  text: 'Lot in invalid!'
              });
    
          return; 
    }
    if(selectedClient) {
      var type = 'Sell-MP';
      var rate = props.mkw.i2;
      if (orderType === 'LIMIT') {
        type = rate < price ? 'Sell-RL' : 'Sell-SL';
        rate = price;
      }
      var order = {
        "orderType": type, "quantity": qty, lot: lot,
        "rate":  userPrice && userPrice > 0 ? userPrice : rate, "scriptId": props.mkw.id, "userId": selectedClient,
        "inLimit": orderType === 'LIMIT' ? true : false,
        "tradeBy": user.adminId, "device": "Browser", "userAgent": navigator.userAgent,
        "dateTime": userPrice && userPrice > 0 ? dateTime : null, "ip": ip
      };

      sendMessage('/app/topic/addorder', JSON.stringify(order));
    } else {
      Swal.fire({
               icon: 'error',
               text: 'Please select client!'
           });
     }  
  };

function validateLot(){
  var valid = true;
  if(script.sn.split("#")[0] === 'MCX'){
    if( lot % 1 !== 0){
      valid = false;
    }
  }
  return valid;
}

  return (<>

    {props.show ? <Card style={{
      zIndex: 1050,
      bottom: '40px',
      marginBottom: '0',
      position: 'fixed',
      width: '90%',
      border: '1px solid white',
    }} className='ms-4   mb-5 '>
      <CardBody>
        <Row>
          <Col xl={12} className='text-end'>
            <CloseButton onClick={e => { setLot(1); setOrderType('MARKET'); props.onHide() }} />
          </Col>
        </Row>
        <Row>
          <Col xl={12} className='text-center fss-1'>
            <Form.Label size="sm">{' ' + mkw.e + ' ' + mkw.s + ' ' + mkw.ix}</Form.Label>
          </Col>
        </Row>



        <Row className='mt-3 fss-07'>
          <Col>HL: {parseFloat(mkw.i9).toFixed(2)} <br /> LO: {parseFloat(mkw.i10).toFixed(2)}</Col>
          <Col>LTP: {parseFloat(mkw.i6).toFixed(2)}</Col>
          <Col>OP: {parseFloat(mkw.i11).toFixed(2)} <br /> CL: {parseFloat(mkw.i12).toFixed(2)}</Col>
        </Row>

        <Row className='mt-3 fss-07'>
          <Col> <label >LOT</label> <Form.Control size="sm" className='bg-light text-black' type="number" min={1} onChange={handleLotChange} value={lot} /></Col>
          <Col> <label >QTY</label> <Form.Control size="sm" className='bg-light text-black' type="number" min={1} value={qty} onChange={handleQtyChange} placeholder="QTY" /></Col>
        </Row>

        <Row className='mt-3 fss-08'>
          <Col xl={3} xs={5}>Select Order Type:</Col>
          <Col xl={9} xs={7}>
            <Form>
              {['radio'].map((type) => (
                <div key={`inline-${type}`} className="mb-1">
                  <Form.Check
                    inline
                    label="MARKET"
                    value='MARKET'
                    name="group1"
                    type={type}
                    id={`inline-${type}-1`}
                    onChange={e => { handleOrderType(e); }}
                    defaultChecked
                  />
                  <Form.Check
                    inline
                    label="LIMIT"
                    name="group1"
                    value='LIMIT'
                    type={type}
                    id={`inline-${type}-2`}
                    onChange={e => { handleOrderType(e); }}
                  />
                </div>
              ))}
            </Form>
          </Col>
        </Row>
        {orderType == 'LIMIT' ?
          <>
            <Row className='fss-08'>
              <Col>
                <label>PRICE</label>
                <Form.Control
                  className='bg-light text-black text-center'
                  size="sm"
                  type="number"
                  min={1}
                  placeholder="PRICE"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </Col>
            </Row>
          </> : ""}
          {user.adminType == 'SUPER_ADMIN'?
            <>
              <Row className='fss-08'>
                <Col xs={12} ><label >USER PRICE</label>
                <Form.Control size="sm" type="number" className='bg-light text-black' min={1} 
                 placeholder="PRICE" onChange={e => setUserPrice(e.target.value)}   />
                </Col>
              </Row>
              <Row className='fss-08 mt-1'>  
                <Col xs={12} ><label >DATE TIME</label>
                <Form.Control size="sm" type="datetime-local"  step="1"  className='bg-light text-black' 
                 value={dateTime} onChange={e=> handleDateTimeChange(e)} onClick={(e) => e.target.showPicker && e.target.showPicker()}  />
                </Col>
              </Row>
              <Row className='fss-08'>
                <Col xs={12} ><label >IP</label>
                <Form.Control size="sm" type="text" className='bg-light text-black'
                 placeholder="IP" onChange={e => setIp(e.target.value)}   />
                </Col>
              </Row>
            </> : ""}

        <Row className='mt-1 fss-08'>
          {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
            <>
              <Col>
                <label >ADMIN</label> <br />
                <AdminDropdown
                  className="ps-0"
                  menuPlacement='top'
                  adminId={user.adminId}
                  setSelectedOption={setSelectedAdmin} />
              </Col>
            </> : ""}

          {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
            <>
              <Col>
              <label >MASTER</label> <br />
                <MasterDropdown
                  menuPlacement='top'
                  adminId={user.adminId}
                  selectedAdmin={selectedAdmin}
                  setSelectedOption={setSelectedMaster}
                  setSelectedMaster={setSelectedMaster}
                  setSelectedBrokerId={setSelectedBrokerId}

                />
              </Col>
            </> : ""}
        </Row>

        <Row className='mt-3 fss-08'>
          {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
            <>
              <Col>
              <label >BROKER</label> <br />
                <BrokerDropdown
                  menuPlacement='top'
                  selectedAdmin={selectedAdmin}
                  selectedMaster={selectedMaster}
                  setSelectedOption={setSelectedBrokerId}
                  setSelectedBrokerId={setSelectedBrokerId}
                  setSelectedSubBrokerId={setSelectedSubBrokerId}
                />
              </Col>
            </> : ""}

          <Col>
          <label >CLIENT</label> <br />
            <ClientDropdown
              menuPlacement='top'
              selectedAdmin={selectedAdmin}
              selectedMaster={selectedMaster}
              selectedBrokerId={selectedBrokerId}
              setSelectedOption={handleSelectedClientChange}
            />
          </Col>
            </Row>

        <Row className='mt-3 fss-08' >
          <Col className='text-start'>
            <Button size='sm' className='w-100 redm-c sellborder' onClick={sellOrder}>SELL @ {parseFloat(mkw.i2).toFixed(2)} </Button>
          </Col>
          <Col className='text-end'>
            <Button size='sm' className='w-100 green-c buyborder' onClick={buyOrder}>BUY @ {parseFloat(mkw.i4).toFixed(2)}</Button>
          </Col>
        </Row>
      </CardBody>
      <CardFooter></CardFooter>
    </Card> : null}</>);
}
export default AddOrderMobile;